(function () {
  if (window.__teaQuizHubFetchBootstrapV2) return;
  window.__teaQuizHubFetchBootstrapV2 = 1;

  function assetBase() {
    var ref =
      document.querySelector('script[src*="quiz-hub-fetch.js"]') ||
      document.querySelector('script[src*="/assets/"]');
    if (!ref || !ref.src || ref.src.indexOf('/assets/') === -1) return '';
    return ref.src.split('/assets/')[0] + '/assets/';
  }

  function loadFreshHomeScript() {
    if (window.__teaQuizFreshHomeV3) return;
    var base = assetBase();
    if (!base) return;
    var script = document.createElement('script');
    script.src = base + 'tea-quiz-fresh-home-v1.js?hubfetch=' + Date.now();
    script.async = false;
    script.setAttribute('data-tea-quiz-fresh-home-v1', '');
    document.head.appendChild(script);
  }

  function isHubPage() {
    if (window.location.hash === '#quiz-results') return true;
    try {
      return new URLSearchParams(window.location.search).get('view') === 'quiz-results';
    } catch (error) {
      return window.location.search.indexOf('view=quiz-results') !== -1;
    }
  }

  if (isHubPage()) {
    loadFreshHomeScript();
  }

  var SECTION_ID = 'template--26698830250095__quiz_constitution_results_hub';

  function runScripts(container) {
    if (!container) return;
    container.querySelectorAll('script').forEach(function (oldScript) {
      var script = document.createElement('script');
      Array.prototype.forEach.call(oldScript.attributes, function (attr) {
        script.setAttribute(attr.name, attr.value);
      });
      script.text = oldScript.textContent;
      oldScript.parentNode.replaceChild(script, oldScript);
    });
  }

  function findHubRoot() {
    return (
      document.querySelector('.quiz-constitution-results-section [data-quiz-constitution-results]') ||
      document.querySelector('#quiz-results [data-quiz-constitution-results]') ||
      document.querySelector('[data-quiz-constitution-results]')
    );
  }

  function needsContentHydrate(root) {
    if (!root) return true;
    if (root.querySelector('.quiz-constitution-results__toc-wrap')) return false;
    if (root.querySelector('.quiz-constitution-results__loading-text')) return true;
    return true;
  }

  function hydrateFromSectionApi() {
    if (!isHubPage()) return;

    var url =
      window.location.pathname +
      '?sections=' +
      encodeURIComponent(SECTION_ID) +
      '&from=quiz&view=quiz-results&_=' +
      Date.now();

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var html = data && data[SECTION_ID];
        if (!html) return;

        var wrap = document.createElement('div');
        wrap.innerHTML = html;
        runScripts(wrap);

        var liveRoot = findHubRoot();
        var apiRoot = wrap.querySelector('[data-quiz-constitution-results]');
        if (needsContentHydrate(liveRoot) && liveRoot && apiRoot) {
          liveRoot.innerHTML = apiRoot.innerHTML;
          runScripts(liveRoot.closest('section') || liveRoot.parentElement || liveRoot);
        }

        if (window.__teaQuizPaintHubNow && !window.__teaQuizBlockHubRestore) {
          try {
            if (sessionStorage.getItem('teaQuizDismissedUntilRetake') !== '1') {
              window.__teaQuizPaintHubNow();
            }
          } catch (error) {
            window.__teaQuizPaintHubNow();
          }
        }
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateFromSectionApi);
  } else {
    hydrateFromSectionApi();
  }

  window.setTimeout(hydrateFromSectionApi, 500);
})();
